import { word } from "@modules/core/utils/i18n"
import { formatCurrency } from "@modules/currency/currency"
import { defaultMonthValue } from "@modules/finances/components/defaultMonth"
import { FinanceCard } from "@modules/finances/components/financeCard"
import { FinanceMonthlyTransferCard } from "@modules/finances/components/financeMonthlyTransferCard"
import { useFinanceStats } from "@modules/finances/hooks/useFinance"
import { useStripeAccount } from "@modules/finances/hooks/useStripeAccount"
import { PayoutEmptyView } from "@modules/financesPayout/components/payoutEmptyView"
import { PayoutTable } from "@modules/financesPayout/components/payoutTable"
import { PayoutEnumApi } from "@modules/financesPayout/gateway/payoutApi"
import { usePayouts } from "@modules/financesPayout/hooks/usePayout"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { useMemo } from "react"

export type UserPayoutLayoutProps = {} & React.HTMLAttributes<HTMLDivElement>

export const UserPayoutLayout: React.FC<UserPayoutLayoutProps> = (props) => {
  const language = useLanguage()
  const payoutEnumApi = PayoutEnumApi.ATHLETE
  const { useStripeAccountStatus } = useStripeAccount()
  const { stripeAccountStatus } = useStripeAccountStatus()
  const isStripeAccountComplete = stripeAccountStatus === "OK"
  const { data: stats, isLoading: loading } = useFinanceStats(isStripeAccountComplete, defaultMonthValue)
  const { data: payouts, isLoading } = usePayouts(payoutEnumApi)
  const totalRegistration = useMemo(() => {
    if (!payouts || payouts.length <= 0) return "--"
    return formatCurrency(
      payouts.reduce((acc, payout) => acc + payout.amount, 0),
      payouts[0].currency,
      language,
    )
  }, [payouts, language])

  return (
    <div className="flex flex-column gap-3" {...props}>
      {/* HEADER */}
      <div className="flex flex-column md:flex-row w-full gap-4">
        <FinanceMonthlyTransferCard
          cardType="Primary"
          cardTitle={word("finances.page.card.monthlyTransfer")}
          loading={loading}
          stats={stats}
          className="flex-grow-1 overflow-hidden rounded-33"
        />
        <FinanceCard
          cardType="Secondary"
          cardTitle={word("finances.payoutLayout.card.totalSinceRegistration")}
          value={totalRegistration}
          loading={false}
          icon="pi pi-wallet"
          className="flex-1 overflow-hidden rounded-33"
        />
      </div>
      {/* BUTTON */}
      {/* <div className="flex flex-row-reverse mt-4 w-full">
        <HUButton
          text={word("global.downloadAll")}
          onClick={() => {}}
          icon={{
            iconView: <Download size={15} color={theme.blackAtheleWhiteOwner} />,
          }}
          type="Right_Icon"
          size="M"
          colorType="Primary"
        />
      </div> */}
      {/* TABLE */}
      <div className="flex mt-4 w-full">
        <PayoutTable
          data={payouts}
          isLoading={isLoading}
          size={payouts.length}
          payoutEnumApi={payoutEnumApi}
          empty={{
            full: true,
            view: <PayoutEmptyView />,
          }}
        />
      </div>
    </div>
  )
}
